export function profilePdfFilename(fullName: string, withPhotos: boolean): string {
  const name = fullName.replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '') || 'profile';
  return `AccheyRishtey-${name}${withPhotos ? '' : '-details'}.pdf`;
}

/**
 * Opens the print dialog for the PDF shown in the preview frame. Browsers that
 * cannot preview PDFs inline, or will not let the page print their PDF viewer
 * (Firefox), get the PDF in a new tab instead, where their viewer can print it.
 */
export function printPdf(
  frame: Pick<Window, 'focus' | 'print'> | null | undefined,
  url: string,
  openInNewTab: (url: string) => void,
): void {
  if (frame) {
    try {
      frame.focus();
      frame.print();
      return;
    } catch {
      // fall through to the new tab
    }
  }
  openInNewTab(url);
}

export function savePdf(url: string, filename: string): void {
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
}
